import { Icon } from "@blocks/components";
import { cn, ucFirst } from "@blocks/utils";
import { Tooltip } from "@wordpress/components";
import { dispatch, useSelect } from "@wordpress/data";
import React, { useCallback, useEffect, useMemo } from "react";
import { DEVICES } from "../constants";
import { deviceStore } from "../store/device-store";

type device = "desktop" | "tablet" | "mobile";

declare var wp: any;
declare var pagenow: any;

const useDeviceType = (): {
	deviceType: device;
	setDeviceType: (deviceType: device) => void;
	DeviceSelector: React.FC;
} => {
	const store: typeof pagenow extends "site-editor"
		? "core/edit-site"
		: "core/edit-post" =
		"site-editor" === pagenow ? "core/edit-site" : "core/edit-post";

	useEffect(() => {
		wp?.customize?.previewedDevice?.bind((v: string) => {
			// @ts-ignore
			dispatch(deviceStore).setDevice(v);
		});
	}, []);

	const deviceType: device = useSelect(
		(select: any) =>
			select(store)
				?.__experimentalGetPreviewDeviceType()
				?.toLowerCase() ??
			select(deviceStore)?.getDevice() ??
			"desktop",
		[]
	);

	const setDeviceType = useCallback(
		(deviceType: device) => {
			// @ts-ignore
			(dispatch(store) as any)?.__experimentalSetPreviewDeviceType(
				ucFirst(deviceType)
			);
			// @ts-ignore
			dispatch(deviceStore).setDevice(deviceType);
			wp?.customize?.previewedDevice(deviceType);
		},
		[store]
	);

	const DeviceSelector = useMemo<React.FC>(() => {
		const DeviceSelectorComponent = () => {
			return (
				<div className="mzb-device-selector">
					<div className="mzb-devices" role="group">
						{Object.entries(DEVICES).map(
							([deviceKey, deviceValue], idx) => (
								<Tooltip
									key={deviceKey + idx}
									text={deviceValue}
									position="top center"
								>
									<button
										className={cn("mzb-device", {
											active: deviceKey === deviceType,
										})}
										onClick={() =>
											setDeviceType(deviceKey as device)
										}
									>
										<Icon
											type="controlIcon"
											name={deviceKey}
											size={20}
										/>
									</button>
								</Tooltip>
							)
						)}
					</div>
				</div>
			);
		};

		return DeviceSelectorComponent;
	}, [deviceType, setDeviceType]);

	return { deviceType, setDeviceType, DeviceSelector };
};

export default useDeviceType;
